
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/material-ui-2024-updates",
      function () {
        return require("private-next-pages/blog/material-ui-2024-updates.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/material-ui-2024-updates"])
      });
    }
  